import { SensorLimitStatus, } from "@reducers/nodes/models/nodes-dto";
import { alarmTypeLabel } from "./alarm-type-label";
import { sensorUnit } from "./sensors";
/** "high" / "low" for a sensor outside its limits; undefined when it is normal or has no status. */
export const limitStatusOf = (statuses, sensorType) => {
    var _a;
    const status = (_a = statuses === null || statuses === void 0 ? void 0 : statuses.find((s) => s.sensorType === sensorType)) === null || _a === void 0 ? void 0 : _a.status;
    if (status === SensorLimitStatus.High)
        return "high";
    if (status === SensorLimitStatus.Low)
        return "low";
    return undefined;
};
/** The sentence naming why a sensor is outside its limits, e.g. "Humidity too high (60 %)". */
export const limitReason = (s, t) => {
    // The limit alarms (8 low / 9 high) name the sensor, so the same wording as the alarm list is used.
    const label = alarmTypeLabel(s.status === SensorLimitStatus.High ? 9 : 8, t, s.sensorType);
    return s.limit == null ? label : `${label} (${s.limit}${sensorUnit(s.sensorType)})`;
};
/** The reasons of every sensor outside its limits, one per line; undefined when none is. */
export const limitReasons = (statuses, t) => {
    const out = (statuses !== null && statuses !== void 0 ? statuses : []).filter((s) => s.status !== SensorLimitStatus.Normal);
    return out.length > 0 ? out.map((s) => limitReason(s, t)).join("\n") : undefined;
};
/**
 * The status of the row chip: the worst of the temperature status the row already had and the sensor statuses. High comes
 * before low; a row that is inactive (no communication / no temperature) stays inactive.
 */
export const worstRowStatus = (base, statuses) => {
    if (base === "inactive")
        return base;
    const all = [
        base,
        ...(statuses !== null && statuses !== void 0 ? statuses : []).map((s) => s.status === SensorLimitStatus.High
            ? "high"
            : s.status === SensorLimitStatus.Low
                ? "low"
                : "normal"),
    ];
    if (all.includes("high"))
        return "high";
    if (all.includes("low"))
        return "low";
    return base;
};
